export const SCREEN_DEFINITIONS = Object.freeze({
  title: { selector: '#title-screen', label: 'title', actions: ['focus:down', 'confirm'] },
  'field-guide': { selector: '#help-modal', label: 'field guide', actions: ['confirm'] },
  forge: { selector: '#forge-modal', label: 'character forge', actions: ['focus:down', 'confirm'] },
  campaign: { selector: '#campaign-modal', label: 'campaign', actions: ['focus:down', 'confirm'] },
  party: { selector: '#party-modal', label: 'party', actions: ['focus:down', 'confirm'] },
  tutorial: { selector: '#tutorial-panel', label: 'tutorial', actions: ['confirm'] },
  cutscene: { selector: '#cutscene', label: 'cutscene', actions: ['confirm'] },
  gameplay: { selector: '#game-shell', label: 'gameplay', actions: ['move', 'attack'] },
  stealth: { selector: '#game-shell', label: 'stealth', actions: ['crouch', 'move'] },
  battle: { selector: '#game-shell', label: 'battle', actions: ['attack', 'dodge'] },
  boss: { selector: '#game-shell', label: 'boss', actions: ['attack', 'dodge'] },
  snuffer: { selector: '#game-shell', label: 'wick-servant', actions: ['move', 'attack'] },
  dialogue: { selector: '#dialogue', label: 'dialogue', actions: ['confirm'] },
  pause: { selector: '#pause-modal', label: 'pause', actions: ['confirm'] },
  victory: { selector: '#victory-modal', label: 'victory', actions: ['confirm'] },
});

export const SCREEN_NAMES = Object.freeze(Object.keys(SCREEN_DEFINITIONS));

export function normalizeScreenName(value) {
  const name = String(value || '').trim().toLowerCase();
  if (name === 'help' || name === 'guide') return 'field-guide';
  if (name === 'game' || name === 'play') return 'gameplay';
  if (name === 'stealth-state' || name === 'sneak') return 'stealth';
  if (name === 'fight') return 'battle';
  if (name === 'voss') return 'boss';
  if (name === 'snuff' || name === 'thrall' || name === 'ward-servant') return 'snuffer';
  return SCREEN_DEFINITIONS[name] ? name : 'title';
}

export function screenDefinition(name) {
  return SCREEN_DEFINITIONS[normalizeScreenName(name)];
}

export function screenPath(name) {
  return `/?bench=1&screen=${encodeURIComponent(normalizeScreenName(name))}`;
}
